/**
* Finds an item by id and returns the item and it's index.
* @param {Array} array - The array containing the object to find.
* @param {String} id - The id of the object in the array to find.
* @returns {Object} - With the index, and item.
*/
export const getItemAndIndex = (array, id) => {
  let index
  const foundItem = array.find((item, i) => {
    index = i
    return item.id === id
  })

  return {
    index,
    item: foundItem,
  }
}

/**
* Updates an objects properties that is in an array found by an id and returns a copy.
* Does not mutate any data.
* @param {Array} array - The array containing the object that will be updated.
* @param {String} id - The id of the object in the array to find.
* @param {Object} props - Props to be added to found object
* @param {Boolean} appendIfNotFound - Should it append object to array if not found?
* @returns {Array} - A new array with the updated object.
*/
export const updateObjectInArrayById = ({
  array,
  id,
  props = {},
  appendIfNotFound = false,
}) => {
  let { item, index } = getItemAndIndex(array, id)
  if (!item && appendIfNotFound) {
    item = {}
    index = array.length
  }
  if (!item && !appendIfNotFound) {
    return array
  }
  return [
    ...array.slice(0, index),
    {
      ...item,
      ...props,
    },
    ...array.slice(index + 1),
  ]
}

/**
* Finds an item in an array by id.
* @param {Array} array - The array to search
* @param {String} id - The id of the object in the array to find.
* @param {String} key - Optional name of key if other than 'id'.
* @returns {Object} - The object whose id matched the id passed in.
*/
export const findById = (array, id, key = 'id') =>
  array.find(item => {
    if (typeof item[key] !== typeof id) {
      throw new Error(`id type mismatch ${typeof item[key]} !== ${typeof id}`)
    }
    return item[key] === id
  })

/**
* Removes objects from an array if a certain key value is empty.
* @param {Array} array - The array to search
* @param {String} key - Key that shouldn't be empty .
* @returns {Array} - Array of objects without the empty key.
*/
export const removeEmptyValues = (array, key) => {
  const hasValue = obj => obj !== undefined && obj.length !== 0
  const filterByKey = item => {
    if (hasValue(item[key])) {
      return true
    }
    return false
  }
  return array.filter(filterByKey)
}

/**
* Removes an item from an array by id.
* Does not mutate any data.
* @param {Array} array - The array containing the object that will be updated.
* @param {String} id - The id of the object in the array to find.
* @returns {Array} - A new array with the updated object.
*/
export const removeItemById = (array, id) =>
  array.filter(item => item.id !== id)



// WEBPACK FOOTER //
// ./src/utils/arrayUtils.js